import { Component, Input } from "@angular/core";
import { FetchQuestionPostDetailQuery } from "src/generated-gql/graphql";
import { SharedModule } from "@bb-vendure/admin-ui/core";
@Component({
  selector: "question-post-comment",
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./message.component.html",
  styleUrl: "./message.component.scss",
})
export class CommentComponent {
  @Input() message: any;

  author() {
    return this.message.isAdmin
      ? `${this.message.administrator.firstName} ${this.message.administrator.lastName}`
      : `${this.message.customer.firstName} ${this.message.customer.lastName}`;
  }

  from() {
    return !this.message.isAdmin ? "(customer)" : "(administrator)";
  }
}
